module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product-container"
  }, [_c('el-card', {
    attrs: {
      "id": "product",
      "body-style": {
        padding: '0px'
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'product-detail',
        params: {
          serialId: _vm.serialId
        }
      }
    }
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "src": _vm.img
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "14px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "color": "#333",
      "width": "240px",
      "height": "40px",
      "overflow": "hidden"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "summary"
  }, [_vm._v(_vm._s(_vm.summary))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.inReduceActivity({
    discountPrice: _vm.discountPrice
  })) ? _c('p', [_vm._v("价格： \n          "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "16px"
    }
  }, [_c('s', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("¥" + _vm._s(_vm._f("zero-price-filter")(_vm.price)))]), _vm._v("\n            ¥" + _vm._s(_vm._f("zero-price-filter")(_vm.price - _vm.discountPrice)) + "\n          ")])]) : _c('p', [_vm._v("价格： "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "16px"
    }
  }, [_vm._v("¥" + _vm._s(_vm._f("zero-price-filter")(_vm.price)))])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-1ea20792!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/Product.vue
// module id = 1013
// module chunks = 40